export const ToastDuration = {
   STANDARD: 5000,
   LONG: 10000,
};